<!-- eslint-disable eqeqeq -->
<template>
  <div class="main-container">
    <div class="head-box">
      <div class="logo-div">
        <img class="logo" src="/static/LOGO.png"/>
      </div>
      <div class="marquee-section">
        <div class="marquee-flex">
          <label>公告:</label>
          <div class="animate-marquee">
            <span>
              註冊送288，首存1000送300！ USDT用戶專享首存送50%！
              限電子｜棋牌｜捕魚獨享！ 電子天天回饋1.2%！不綁馬！
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="video-frame">
        <div class="frame-box">
          <iframe width="100%" height="100%"
            src="https://www.youtube.com/embed/6YFGrmBmcKM?autoplay=1&mute=1&controls=0&loop=1&playlist=6YFGrmBmcKM"
            allowfullscreen class="frame-size">
          </iframe>
        </div>
    </div>
    <div class="sign-section">
      <div class="sign-title">
        <img class="title-img" src="/static/sign-title.png"/>
      </div>
    </div>
    <SignForm></SignForm>
    <div class="footer-font-size">
      <p>十二年誠信 | 雄厚實力 | 用心服務</p>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import SignForm from './components/SignForm'
export default {
  name: 'App',

  components: {
    SignForm
  },
  data () {
    return {

    }
  },
  computed: {

  },
  watch: {
  },

  created () {

  },


  mounted () {

  },
  methods: {



  }
}
</script>




// WEBPACK FOOTER //
// src/home.vue